var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIconWorkflowSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0_5626_6603)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5626_6603",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5626_6603",
    transform: "scale(0.0833333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5626_6603",
    width: 12,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAExSURBVHgBfVFLSsRAEK3qaUh3LzTM2oVewOgBRC/gEQacEzhbcZGgK08xiAfwCCqCiIghmQvoAcSAzExnMSmrGxOaoFMQUnn1e+8FoRd3ADJWasvl+9a+9+vYJnkcx8LaUxTihAAeGIqRaJOI7netveBG6qZeAUxhTF5oPelvnBmTlsa8PQ+HGx3IwGWh1Fl7Kbzq3rzsPDcm6ygx8JgsFgeuYVDXtyuicUMkpRDTJoqOtZSrej4vk+VyR+ZKbQPRpxdZVRV/jweIU36AB0cO+2VRul7hzyB+hbxZnexr4aVeg9iz9oOdOOqcQrxhOiNHy10KNXU2s4asiKLJf6JnSqWtaB9PANrbyoWQhRsotb5i/i8thgFv5ELKP+uQ84YL3ywu4fyaHcxgXTg3vHt/xA/45YAYE+lAowAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIconWorkflowSteps);
export default __webpack_public_path__ + "static/media/cancel-icon-workflow-steps.d90a5e3ddf64bf8efd7c903c90b100d7.svg";
export { ForwardRef as ReactComponent };